import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import type { ActivityHistoriesGroupedByUserAndDate, AppState } from '@/types'
import { clsJoin } from '@/utils'
import { getProjectCreateDate } from '../../helper'
import { UserItem } from './components/UserItem'
import css from './styles.module.css'

type Props = {
  id: string
  date: string
  totalChanges: number
  groupedByUserAndDate: ActivityHistoriesGroupedByUserAndDate[]
  activeAccordion: Record<string, boolean>
  projectId: string
  singlePreview: string | null
  onSetActiveAccordion: (
    prev: (obj: Record<string, boolean>) => Record<string, boolean>
  ) => void
}

export const AccordionItem: React.FC<Props> = ({
  id,
  totalChanges,
  groupedByUserAndDate,
  date,
  activeAccordion,
  projectId,
  singlePreview,
  onSetActiveAccordion,
}) => {
  const [changesIsOpen, setChangesIsOpen] = useState<string | null>(null)

  const auth = useSelector<AppState, any>(({ auth }) => auth)

  const handleAccordionClick = () => {
    onSetActiveAccordion((prev) => ({
      ...prev,
      [id]: !activeAccordion[id],
    }))
  }

  const cn = clsJoin(css.accordion_button, activeAccordion[id] && css.ative)

  return (
    <>
      <button className={cn} onClick={handleAccordionClick}>
        <AngleRight className={css.accordion_icon} />
        <span className={css.accordion_name}>
          {getProjectCreateDate(date, auth.dateFormat)}
        </span>
        <span className={css.accordion_changes}>{totalChanges} changes</span>
      </button>

      {activeAccordion[id] &&
        groupedByUserAndDate.map((grouped, index: number) => (
          <UserItem
            key={`${grouped}/${index}`}
            {...grouped}
            projectId={projectId}
            changesIsOpen={changesIsOpen}
            singlePreview={singlePreview}
            onSetChangesIsOpen={setChangesIsOpen}
          />
        ))}
    </>
  )
}
